import epsClient from 'enrollment-platform/api/eps.client'

import {
  CreateRecruitingRequest,
  RecruitingResponse,
  RecruitingStatusEnum,
} from '../schema'

export interface GetRecruitingParams {
  clientPublicKey: string
  benefitEffectiveStartDate: string
  benefitEffectiveEndDate: string
  sort: string
  order: 'ASC' | 'DESC'
  page: number
  pageSize: number
  status?: RecruitingStatusEnum
}

const RECRUITING_API_PATH = 'api/v1/recruiting'

export async function getRecruiting(
  params: GetRecruitingParams
): Promise<RecruitingResponse> {
  const { status, pageSize, ...rest } = params
  const queryParams = {
    ...rest,
    limit: pageSize,
    ...(status != null ? { status } : {}),
  }
  const { data } = await epsClient.get<RecruitingResponse>(
    RECRUITING_API_PATH,
    { params: queryParams }
  )
  return data ?? { data: [], total: 0, page: 0, pageSize: 0 }
}

export interface SendEmailResult {
  isSuccess: boolean
  errorMessage?: string
}

export interface CreateRecruitingResponse {
  id: string
  expiresAt: string
  sendEmailResult: SendEmailResult
}

export async function postRecruiting(
  body: CreateRecruitingRequest
): Promise<CreateRecruitingResponse> {
  const { data } = await epsClient.post<CreateRecruitingResponse>(
    RECRUITING_API_PATH,
    body
  )
  return data
}

export async function deleteRecruiting(id: string): Promise<void> {
  const { data } = await epsClient.delete(`${RECRUITING_API_PATH}/${id}`)
  return data ?? undefined
}
